import { render, staticRenderFns } from "./WordPressImport.vue?vue&type=template&id=e1d9840e&"
import script from "./WordPressImport.vue?vue&type=script&lang=js&"
export * from "./WordPressImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports